import React, { useEffect } from 'react';
import {
  LinearProgressBar,
  Button,
  Shimmer,
} from '@techsoftware/happay-widgets';
import PropTypes from 'prop-types';
import Grid from '@techsoftware/happay-widgets/Grid';
import Card from '@techsoftware/happay-widgets/Card';
import Tabs from '@techsoftware/happay-widgets/Tabs';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import Popup from '@techsoftware/happay-widgets/Popup';
import { onKeyPress } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import {
  formatDate,
  currencyFormatter,
  dateDifference,
} from '../../helpers/genericFormator';
import PaymentInfo from '../bill/paymentInfo';
import history from '../../utils/history';
// import Analytics from '../../containers/analyticsContainer';
import NOBALANCE from '../../assets/images/illustration.svg';
import DynamicButtons from '../dynamicButtons';
import Expenses from '../../containers/expenseContainer';
import BalanceSummaryPopup from '../BalanceSummary';

const buttonsArr = [
  {
    text: 'Add Invoice',
    action: () =>
      history.push({
        pathname: '/invoice/myinvoice/createView',
        state: { prevPath: '/dashboard' },
      }),
    iconType: 'add',
    variant: 'primary',
  },
  {
    text: 'Add Vendor',
    action: () =>
      history.push({
        pathname: '/vendor/myvendor/createView',
        state: { prevPath: '/dashboard' },
      }),
    iconType: 'add',
    variant: 'primary',
  },
];

const pendingTabs = ['Invoices', 'Vendors'];

export default function AdminDashboard(props) {
  const [state, setState] = React.useState({
    payInfoDialog: false,
    activeIndex: 0,
  });
  const limit = parseFloat(props.userLimit.spent / props.userLimit.given);
  // eslint-disable-next-line no-restricted-globals
  useEffect(() => {
    props.getCurrentBalance({});
    if (!props.verAccDetails) {
      props.getVirtualAccDetails();
    }
  }, []);

  useEffect(
    () => () => {
      props.clearBillStore(); // This works as willUnmount
    },
    [],
  );

  // const percentage = isNaN(limit * 100) ? 0 : (limit * 100).toFixed(2);
  const { userInfo = {} } = props;

  const getRemainngDaysLogic = (date, status, totalAmt) => {
    const obj = {
      color: 'blue',
      text: '',
      warningMsg: '',
    };
    if (totalAmt === 0) {
      return obj;
    }
    if (status === 'paid') {
      obj.color = 'green';
      obj.text = 'Cleared';
      return obj;
    }
    if (status === 'carried_over') {
      return obj;
    }
    const remainingDays = dateDifference(new Date(), date);
    if (remainingDays >= 0 && remainingDays <= 2) {
      obj.color = 'orange';
      obj.warningMsg = '';
      switch (remainingDays) {
        case 0:
          obj.text = 'Due date today';
          break;
        case 1:
          obj.text = `${remainingDays} day remaining`;
          break;
        case 2:
          obj.text = `${remainingDays} days remaining`;
          break;
        default:
          break;
      }
    } else if (remainingDays > 2) {
      obj.text = `${remainingDays} days remaining`;
      obj.warningMsg = '';
    } else if (totalAmt > 10) {
      obj.color = 'red';
      obj.text = `${remainingDays * -1} day${
        remainingDays === -1 ? '' : 's'
      } overdue`;
      obj.warningMsg = '';
    } else {
      obj.color = 'blue';
      obj.text = '';
    }
    return obj;
  };

  const changetoDetailView = event => {
    const billId = props.adminBalance.bill_id;
    history.push({ pathname: `/balancedetail/${billId}` });
  };

  const relativePercentageValue = (val, total) => {
    const perc = ((val / total) * 100).toFixed(2);
    if (perc >= 0.05 && perc <= 10) {
      val = ((10 / 100) * total).toFixed(3);
    } else if (perc < 0.05) {
      val = ((3 / 100) * total).toFixed(3);
    }
    return val;
  };
  const billData = props.adminBalance || {};

  const remainingDaysObj =
    (billData.grace_period_end_date &&
      getRemainngDaysLogic(
        billData.grace_period_end_date,
        billData.status,
        billData.remaining_balance,
      )) ||
    {};

  const myLimitObj = {
    userLimit: props.userLimit,
    defaultCurrency: props.userInfo.default_currency,
  };
  const { orgLimit, userLimit } = props;
  const creditLineObj = props.isAdmin ? orgLimit : userLimit;
  const cardObj = {
    value: creditLineObj?.card_amount
      ? relativePercentageValue(
          creditLineObj.card_amount,
          creditLineObj.available,
        )
      : 0,
    style: {
      boxShadow: '0 2px 8px 0 rgba(28, 140, 81, 0.6)',
      background:
        'linear-gradient(-45deg, transparent 33%, rgba(255, 255, 255, .2) 33%, rgba(255, 255, 255, .2) 66%, transparent 66%)',
      backgroundSize: '30px',
      borderRadius: '11px 0px 0px 11px',
    },
    className: 'card_amount_bg',
  };
  const invoiceObj = {
    value: creditLineObj?.invoice_amount
      ? relativePercentageValue(
          creditLineObj.invoice_amount,
          creditLineObj.available,
        )
      : 0,
    style: {
      boxShadow: '0 2px 8px 0 rgba(28, 140, 81, 0.6)',
      background:
        'linear-gradient(-45deg, transparent 33%, rgba(255, 255, 255, .2) 33%, rgba(255, 255, 255, .2) 66%, transparent 66%)',
      backgroundSize: '30px',
      borderRadius: '0px 11px 11px 0px',
    },
    className: 'invoice_amount_bg',
  };

  const data = [cardObj, invoiceObj];

  const hadleClickAll = () => {
    let url = '';
    if (pendingTabs[state.activeIndex] === 'Invoices') {
      if (props.isAdmin) {
        url = '/invoice/myapproval?tab=Pending';
      } else {
        url = '/invoice/myinvoice?tab=All';
      }
    } else if (props.isAdmin) {
      url = '/vendor/myapproval?tab=Pending';
    } else {
      url = '/vendor/myvendor?tab=All';
    }
    history.push(url);
  };

  return (
    <Grid container justify="center">
      <Grid item xs={24} sm={24} md={24} lg={24} xl={18}>
        <Grid
          container
          direction="row"
          // justify="flex-end"
          alignItems="center"
          className="margin-t-10"
        >
          <Grid item xs={12} className="heading-h1 hw-text-body">
            Dashboard
          </Grid>
          <Grid container item xs={12} justify="flex-end">
            {' '}
            <DynamicButtons id="dashboard-buttons" buttonsArr={buttonsArr} />{' '}
          </Grid>
        </Grid>
        <>
          {/* <div  // uncomment it when there is any notice to showcase . 
           style={{ 
            background: `url(${MASTERCARDBANNER})`,
            backgroundColor: '#f8d1d1',
            minHeight: '84px',
            backgroundSize: 'cover',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            padding: '20px 269px 20px 20px',
          }}
        >
          <img src={BELL} alt="bell-svg" />
          <span className="margin-l-20">
            <div className="font-14 fw-600" style={{ color: '#282e2b' }}>
              We had to temporarily stop Mastercard issuance to new users due to
              <a
                href="https://rbi.org.in/scripts/BS_PressReleaseDisplay.aspx?prid=51895"
                target="_blank"
                className="fw-600"
                style={{ color: '#1c8c51' }}
              >
                {' '}
                RBI mandate{' '}
              </a>
            </div>
            <div style={{ color: '#292e2c' }} className="body">
              Don’t panic ! You can keep on assigning cards to existing users.
              We are working hard to resolve this.
            </div>
          </span>
        </div> */}
          {/* {props.isAdmin && ( */}
          <h2 className="hw-text-heading defaultLetterSpace fw-400">
            Credit Line Details: Overview of{' '}
            {formatDate(new Date(), 'MMMM YYYY')}
          </h2>
          <Grid container alignItems="center" className="linear-bar-wrapper">
            <Grid item xs={16} sm={24} md={16} lg={16} className="padding-r-30">
              <div className="section-heading dark letter-spacing-20 margin-b-14">
                {`${props.isAdmin ? 'Company' : 'User'}`} Credit Line
              </div>
              <div className="font-24 fw-500 medium letter-spacing-30">
                {currencyFormatter(
                  creditLineObj.given,
                  userInfo.default_currency,
                )}
              </div>
              <div className="margin-t-24 linearbar">
                <LinearProgressBar
                  // primaryColor="#962f87"
                  secondaryColor="#e0e0e0"
                  dataPoints={data || []}
                  lineHeight={16}
                  totalLimit={creditLineObj.given}
                  usedLimit={creditLineObj.spent}
                />
                <Grid container direction="row" justify="space-between">
                  <div>
                    <Grid
                      container
                      direction="row"
                      className="margin-t-20 margin-b-5"
                    >
                      <div className="box">
                        <span className="span card"></span>
                      </div>
                      <div className="status hw-text-body margin-l-10 letter-spacing-20">
                        Card Spends
                      </div>
                    </Grid>
                    <div className="section-heading dark font-18 letter-spacing-30">
                      {currencyFormatter(
                        creditLineObj?.card_amount || 0,
                        userInfo.default_currency,
                      )}
                    </div>
                  </div>
                  <div>
                    <Grid
                      container
                      direction="row"
                      className="margin-t-24 margin-b-5"
                    >
                      <div
                        className="box"
                        // style={{ backgroundColor: '#6c6fd9' }}
                      >
                        <span className="span invoice"></span>
                      </div>
                      <div className="status hw-text-body margin-l-10 letter-spacing-20">
                        Invoice Payments
                      </div>
                    </Grid>
                    <div className="section-heading dark font-18 letter-spacing-30">
                      {currencyFormatter(
                        creditLineObj?.invoice_amount || 0,
                        userInfo.default_currency,
                      )}
                    </div>
                  </div>
                  <div>
                    <Grid
                      container
                      direction="row"
                      className="margin-t-24 margin-b-5"
                    >
                      <div
                        className="box"
                        // style={{ backgroundColor: '#f5e2f2' }}
                      >
                        <span className="span available"></span>
                      </div>
                      <div className="status hw-text-body margin-l-10 letter-spacing-20">
                        Credit Balance
                      </div>
                    </Grid>
                    <BalanceSummaryPopup
                      id="bar-wallet-limit"
                      available={creditLineObj?.available}
                      currency={userInfo.default_currency}
                      schedule={creditLineObj?.scheduled_payment}
                    />
                  </div>
                </Grid>
              </div>
            </Grid>
            <Grid
              item
              xs={8}
              sm={24}
              md={8}
              lg={8}
              className="border-l padding-l-40"
            >
              {Object.keys(billData).length &&
              !('error' in billData) &&
              props.isAdmin ? (
                <Grid container xs={24} alignItems="flex-start">
                  <Grid
                    item
                    container
                    xs={24}
                    className="section-heading dark margin-b-24 letter-spacing-20"
                  >
                    Credit Statement for{' '}
                    {formatDate(billData.to_date, 'MMM, YYYY ')}
                  </Grid>
                  <Grid
                    container
                    item
                    direction="column"
                    justify="flex-start"
                    alignItems="flex-start"
                    xs={12}
                  >
                    <Grid
                      item
                      xs={24}
                      className="status hw-text-body letter-spacing-20 padding-b-5"
                    >
                      Total payable
                    </Grid>
                    <Grid
                      item
                      xs={24}
                      className="section-heading dark font-18 letter-spacing-30"
                    >
                      {currencyFormatter(billData.payable_amount)}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    item
                    direction="column"
                    xs={12}
                    justify="flex-start"
                    alignItems="flex-start"
                    className="section-heading dark padding-l-10 padding-b-24 letter-spacing-30"
                  >
                    <Grid
                      item
                      xs={24}
                      className="status hw-text-body letter-spacing-20 padding-b-5"
                    >
                      Due Date
                    </Grid>
                    <Grid
                      item
                      xs={24}
                      className="section-heading dark font-18 letter-spacing-30 padding-b-10"
                    >
                      {formatDate(
                        billData.grace_period_end_date,
                        'DD MMM, YYYY',
                      )}
                    </Grid>
                    {billData.status !== 'carried_over' ? (
                      <>
                        <Grid
                          container
                          item
                          xs={24}
                          // justify="flex-end"
                          className={`status ${remainingDaysObj.color}`}
                        >
                          {remainingDaysObj.text}
                        </Grid>
                      </>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} className="align-self-center">
                    {/* <Button
                        type="button"
                        text="View Details"
                        variant="tertiary"
                        size="medium"
                        endIcon='dropright'
                        buttonParentStyles={{ padding: '10px 12px', height:'40px' }}
                        // className="btn-view-details bill-view"
                        onClick={changetoDetailView}
                      /> */}
                    {/* <span className="link-text"> */}
                    <span
                      className="link-text view-more-cont focus-visible"
                      onClick={changetoDetailView}
                      tabIndex={0}
                    >
                      <span className="underline-text">View Details </span>
                      <Icons
                        type="dropright"
                        size="small"
                        customIconStyle={{ top: '3px', position: 'relative' }}
                      />
                    </span>
                    {/* </span> */}
                  </Grid>
                  <Grid container item xs={12} className="padding-l-10">
                    <Button
                      type="button"
                      text="Pay Here"
                      variant="secondary"
                      size="medium"
                      buttonParentStyles={{
                        padding: '10px 22px',
                        height: '40px',
                      }}
                      // className="btn-view-details bill-view"
                      onClick={event => {
                        setState({ ...state, payInfoDialog: true });
                        event.stopPropagation();
                      }}
                    />
                  </Grid>
                  {/* <Grid item xs={12} className="info-text regular">
                      Click on Pay now to receive the bank account number to
                      clear bills.
                    </Grid> */}
                </Grid>
              ) : 'error' in billData || !props.isAdmin ? (
                <Grid container xs={24} justify="center" alignItems="center">
                  <Grid
                    container
                    item
                    xs={24}
                    justify="center"
                    alignItems="center"
                  >
                    <img src={NOBALANCE} alt="no content" />
                  </Grid>
                  <Grid
                    container
                    item
                    xs={24}
                    justify="center"
                    alignItems="center"
                    className="body normal text-newline padding-tb-16"
                  >
                    You have no pending bills currently
                  </Grid>
                  <Grid
                    container
                    item
                    xs={24}
                    justify="center"
                    alignItems="center"
                  >
                    <Button
                      type="button"
                      text="Payment details"
                      variant="secondary"
                      size="medium"
                      buttonParentStyles={{ height: '40px' }}
                      onClick={event => {
                        setState({ ...state, payInfoDialog: true });
                        event.stopPropagation();
                      }}
                    />
                  </Grid>
                </Grid>
              ) : (
                <Shimmer height={165} width={300} />
              )}
            </Grid>
            <PaymentInfo
              open={state.payInfoDialog}
              accData={props.verAccDetails}
              onPayInfoClose={value => {
                setState({ ...state, payInfoDialog: value });
              }}
            />
          </Grid>
          <h2 className="hw-text-heading defaultLetterSpace padding-t-16 fw-400">
            {props.isAdmin ? 'Pending Approvals' : 'My Requests'}
          </h2>
          <Grid container alignItems="flex-start">
            <Card
              defaultOpen
              id="card-invoice-product-dashboard"
              cardContentStyle={{ padding: '0px' }}
              title={
                <Tabs
                  onTabChange={(ev, value) => {
                    setState({ ...state, activeIndex: value });
                  }}
                  activeIndex={state.activeIndex}
                  isSmallView
                  noBorder
                  tabName={pendingTabs}
                />
              }
              cardHeaderStyle={{
                height: '52px',
                borderBottom: 'solid 1px #bdbdbd',
                padding: '10px',
              }}
              hideExpandIcon
              stopToggle
              cardRightIcons={
                <div
                  className="d-flex margin-r-10 hw-text-body"
                  onClick={hadleClickAll}
                >
                  <span
                    tabIndex={0}
                    onKeyDown={event =>
                      onKeyPress(event, () => hadleClickAll())
                    }
                    className="link-text view-more-cont focus-visible"
                  >
                    <span className="underline-text">View All </span>
                    <Icons
                      type="dropright"
                      size="small"
                      customIconStyle={{ top: '3px', position: 'relative' }}
                    />
                  </span>
                </div>
              }
              wrapperStyle={{ width: '100%' }}
            >
              <div className="invoice-dashboard-table">
                <Expenses
                  fromPage="dashboard"
                  isAdminView={props.isAdmin}
                  activeContainer={pendingTabs[state.activeIndex]}
                  pathname={
                    pendingTabs[state.activeIndex] === 'Invoices'
                      ? `dashboard${props.isAdmin ? 'Admin' : 'User'}Invoice`
                      : `dashboard${props.isAdmin ? 'Admin' : 'User'}Vendor`
                  }
                />
              </div>
            </Card>
          </Grid>
        </>
        {/* )} */}
      </Grid>
    </Grid>
  );
}
AdminDashboard.propTypes = {
  orgLimit: PropTypes.object,
  userLimit: PropTypes.object,
  isAdmin: PropTypes.bool,
  userInfo: PropTypes.object,
  getCurrentBalance: PropTypes.func,
  adminBalance: PropTypes.object,
  clearBillStore: PropTypes.func,
  getVirtualAccDetails: PropTypes.func,
  verAccDetails: PropTypes.object,
};

AdminDashboard.defaultProps = {
  orgLimit: {
    given: 0,
    spent: 0,
    available: 0,
  },
  userLimit: {
    given: 0,
    spent: 0,
    available: 0,
  },
  isAdmin: false,
};
